import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials, testimonialsTitle } from '../data/content';
export function Testimonials() {
  return <Section tone="base" eyebrow="Reseñas verificadas" title={testimonialsTitle} data-id="element-178" data-mp="3fze45yusr5w7">
      <ul className="mx-auto max-w-narrow divide-y divide-white/5" data-id="element-179" data-mp="3b0kobzs1f2sv">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-180" data-mp="36ypokzpr8xh7">
            <div className="flex items-start gap-3" data-id="element-181" data-mp="31yl6x6d41wpe">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-night-600 font-display text-xs font-bold text-gold-300 ring-1 ring-gold-400/25" data-id="element-182" data-mp="2x004d0adz0xs">
                {item.initials}
              </span>
              <span data-id="element-183" data-mp="v8wu4c4erodr">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-184" data-mp="v7c7d8oc59qg">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-185" data-mp="h5oqhd9wga8h" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-bold tracking-tight text-ink" data-id="element-186" data-mp="79ldfcdier6r">
                  {item.author}
                </span>
                <span className="text-sm text-faint" data-id="element-187" data-mp="zvwfyskof267">{item.role}</span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-muted md:text-xl" data-id="element-188" data-mp="14vskcsxacvma">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}